import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import StaffList from "./StaffList";
import axiosInstance from "../../Api/axios.instance";
import AddStaff from "./AddStaff";
import AddTeacher from "./AddTeacher";
import TeacherLeave from "./TeacherLeave";
import { getClasses } from "../ClassSubjects/Classes";
import useSession from "../../CustomHooks/useSession";
import { getSubjects } from "../ClassSubjects/Subjects";
import PendingApprovals from "./PendingApprovals";
import TeacherLeft from "./TeacherLeft";

export function getStaff() {
  return new Promise(async (resolve, reject) => {
    try {
      const { data, status } = await axiosInstance.get("/staff");
      if (status === 200) {
        resolve(data);
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function getTeachers() {
  return new Promise(async (resolve, reject) => {
    try {
      const { data, status } = await axiosInstance.get("/teachers");
      if (status === 200) {
        resolve(data);
      }
    } catch (error) {
      reject(error);
    }
  });
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Staff() {
  const [value, setValue] = React.useState(0);
  const [staff, setStaff] = React.useState([]);
  const [pendingStaff, setPendingStaff] = React.useState([]);
  const [leftStaff, setLeftStaff] = React.useState([]);
  const [classes, setClasses] = React.useState([]);
  const [subjects, setSubjects] = React.useState([]);
  const { accesLevel, access } = useSession();

  const UserData = JSON.parse(localStorage.User);
  const isSchoolHR = UserData?.username === "schoolhr";
  // Add near the top of Staff(), alongside UserData / isSchoolHR
  const RoleData = JSON.parse(localStorage.getItem("Role") || "null");
  const rolePermissions = RoleData ? JSON.parse(RoleData.permissions) : null;
  const staffPagePermission = rolePermissions?.pages?.find(
    (p) => p.title === "Staff",
  );
  const canAddStaff = isSchoolHR || staffPagePermission?.create === true;

  React.useEffect(() => {
    _fetchStaff();
    _fetchClasses();
    _fetchSubjects();
    if (isSchoolHR) {
      _fetchPendingStaff();
      _fetchLeftStaff();
    }
  }, []);

  const _fetchStaff = async () => {
    try {
      if (accesLevel === "SCHOOL" || accesLevel === "ADMIN") {
        const accessObject = Object.assign({}, access);
        const schoolID =
          accesLevel === "SCHOOL"
            ? accessObject[0].SchoolId
            : JSON.parse(localStorage.getItem("UserAccess"))[0].SchoolId;
        const { data, status } = await axiosInstance.get(
          `/teachers/by-school-id/${schoolID}`,
        );
        if (status === 200) setStaff(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const _fetchClasses = async () => {
    try {
      const response = await getClasses();
      setClasses(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const _fetchSubjects = async () => {
    try {
      const response = await getSubjects();
      setSubjects(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const _fetchPendingStaff = async () => {
    try {
      const { data, status } = await axiosInstance.get(
        "/teachers/pending-approvals",
      );
      if (status === 200) setPendingStaff(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  // const _fetchPendingStaff = async () => {
  //   try {
  //     const { data, status } = await axiosInstance.get(
  //       "/teachers/pending-approvals",
  //     );
  //     if (status === 200) setPendingStaff(data.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const _fetchLeftStaff = async () => {
    try {
      if (accesLevel === "SCHOOL" || accesLevel === "ADMIN") {
        const accessObject = Object.assign({}, access);
        const schoolID =
          accesLevel === "SCHOOL"
            ? accessObject[0].SchoolId
            : JSON.parse(localStorage.getItem("UserAccess"))[0].SchoolId;
        const { data, status } = await axiosInstance.get(
          `/teachers/left-by-school-id/${schoolID}`,
        );
        if (status === 200) setLeftStaff(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (event, newValue) => setValue(newValue);
  // const showLeaveTab = accesLevel === "ADMIN";
  const showLeaveTab = accesLevel === "SCHOOL" || isSchoolHR;

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          value={value}
          onChange={handleChange}
        >
          <Tab label="Staff List" value={0} {...a11yProps(0)} />
          {/* <Tab label="Add New Staff" value={1} {...a11yProps(1)} /> */}
          {canAddStaff && (
            <Tab label="Add New Staff" value={1} {...a11yProps(1)} />
          )}
          {isSchoolHR && (
            <Tab label="Pending Approvals" value={2} {...a11yProps(2)} />
          )}
          {isSchoolHR && (
            <Tab label="Left Teacher" value={3} {...a11yProps(3)} />
          )}
          {showLeaveTab && (
            <Tab label="Apply for Leave" value={4} {...a11yProps(4)} />
          )}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <StaffList
          staff={staff}
          refreshStaff={_fetchStaff}
          refreshPending={_fetchPendingStaff}
          refreshLeftStaff={_fetchLeftStaff}
          subjects={subjects}
        />
      </TabPanel>
      {canAddStaff && (
        <TabPanel value={value} index={1}>
          <AddStaff
            getStaff={_fetchStaff}
            classes={classes}
            subjects={subjects}
            staff={staff}
          />
        </TabPanel>
      )}
      {/* <TabPanel value={value} index={1}>
        <AddStaff
          getStaff={_fetchStaff}
          classes={classes}
          subjects={subjects}
          staff={staff}
        />
      </TabPanel> */}
      {isSchoolHR && (
        <TabPanel value={value} index={2}>
          <PendingApprovals
            pendingStaff={pendingStaff}
            refreshPending={_fetchPendingStaff}
            refreshStaff={_fetchStaff}
          />
        </TabPanel>
      )}
      {isSchoolHR && (
        <TabPanel value={value} index={3}>
          <TeacherLeft
            leftStaff={leftStaff}
            refreshLeftStaff={_fetchLeftStaff}
            refreshStaff={_fetchStaff}
          />
        </TabPanel>
      )}
      {showLeaveTab && (
        <TabPanel value={value} index={4}>
          <TeacherLeave staff={staff} />
        </TabPanel>
      )}
    </Box>
  );
}
